import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { deleteAdminMedia, fetchAdminMediaPage, updateAdminMedia, uploadAdminMedia, uploadAdminMediaBatch, } from '@/api/adminMedia';
import { ADMIN_PAGE_SIZE } from '@/api/adminTypes';
import { parseApiErrorMessage } from '@/api/errors';
import { pickMediaUrl } from '@/api/mappers/media';
import { useAsyncData } from '@/hooks/useAsyncData';
import { AdminModal } from '@/pages/admin/ui/AdminModal';
import { AdminPageHeader } from '@/pages/admin/ui/AdminPageHeader';
import { AdminPagination } from '@/pages/admin/ui/AdminPagination';
import { useAdminToast } from '@/pages/admin/ui/AdminToast';
import { formatAdminDate } from '@/pages/admin/ui/adminFormat';
export function MediaPage() {
    const { show } = useAdminToast();
    const [page, setPage] = useState(0);
    const [tick, setTick] = useState(0);
    const [type, setType] = useState('IMAGE');
    const [name, setName] = useState('');
    const [files, setFiles] = useState([]);
    const [busy, setBusy] = useState(false);
    const [editing, setEditing] = useState(null);
    const [editName, setEditName] = useState('');
    const [editFile, setEditFile] = useState(null);
    const list = useAsyncData(['admin-media', page, tick], () => fetchAdminMediaPage(page, ADMIN_PAGE_SIZE));
    const items = list.data?.content ?? [];
    const upload = async () => {
        if (files.length === 0) {
            show('Выберите файлы', 'warning');
            return;
        }
        setBusy(true);
        try {
            if (files.length === 1)
                await uploadAdminMedia(files[0], type, name);
            else
                await uploadAdminMediaBatch(files, type);
            show('Загружено');
            setFiles([]);
            setName('');
            setTick((n) => n + 1);
        }
        catch (err) {
            show(parseApiErrorMessage(err, 'Не удалось загрузить'), 'danger');
        }
        finally {
            setBusy(false);
        }
    };
    const saveEdit = async () => {
        if (!editing)
            return;
        setBusy(true);
        try {
            await updateAdminMedia(editing.id, editName, editFile);
            show('Сохранено');
            setEditing(null);
            setTick((n) => n + 1);
        }
        catch (err) {
            show(parseApiErrorMessage(err, 'Не удалось сохранить'), 'danger');
        }
        finally {
            setBusy(false);
        }
    };
    const remove = async (item) => {
        if (!window.confirm(`Удалить медиа #${item.id}?`))
            return;
        setBusy(true);
        try {
            await deleteAdminMedia(item.id);
            show('Удалено');
            setTick((n) => n + 1);
        }
        catch (err) {
            show(parseApiErrorMessage(err, 'Не удалось удалить'), 'danger');
        }
        finally {
            setBusy(false);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(AdminPageHeader, { title: "\u041C\u0435\u0434\u0438\u0430", subtitle: "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0438 \u0444\u0430\u0439\u043B\u044B" }), _jsxs("div", { className: "admin-toolbar", children: [_jsxs("select", { className: "admin-select", value: type, onChange: (e) => setType(e.target.value), children: [_jsx("option", { value: "IMAGE", children: "IMAGE" }), _jsx("option", { value: "VIDEO", children: "VIDEO" })] }), _jsx("input", { className: "admin-input", placeholder: "\u0418\u043C\u044F (\u0434\u043B\u044F \u043E\u0434\u043D\u043E\u0433\u043E \u0444\u0430\u0439\u043B\u0430)", value: name, onChange: (e) => setName(e.target.value) }), _jsx("input", { type: "file", multiple: true, onChange: (e) => setFiles(Array.from(e.target.files ?? [])) }), _jsx("button", { type: "button", className: "admin-btn admin-btn-primary", disabled: busy, onClick: () => void upload(), children: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C" })] }), _jsx("div", { className: "admin-table-wrap", children: _jsxs("table", { className: "admin-table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "ID" }), _jsx("th", { children: "\u041F\u0440\u0435\u0432\u044C\u044E" }), _jsx("th", { children: "\u0418\u043C\u044F" }), _jsx("th", { children: "\u041F\u0443\u0442\u044C" }), _jsx("th", { children: "\u0422\u0438\u043F" }), _jsx("th", { children: "\u0421\u043E\u0437\u0434\u0430\u043D\u043E" }), _jsx("th", {})] }) }), _jsx("tbody", { children: items.map((item) => {
                                const src = pickMediaUrl(item, 'pathThumb', 'path');
                                return (_jsxs("tr", { children: [_jsx("td", { children: item.id }), _jsx("td", { children: item.type === 'VIDEO' ? (_jsx("video", { className: "admin-thumb", src: src, muted: true })) : (_jsx("img", { className: "admin-thumb", src: src, alt: "" })) }), _jsx("td", { children: item.name || '—' }), _jsx("td", { children: item.path }), _jsx("td", { children: item.type }), _jsx("td", { children: formatAdminDate(item.createdAt) }), _jsx("td", { children: _jsxs("div", { className: "admin-btn-row", children: [_jsx("button", { type: "button", className: "admin-btn", onClick: () => {
                                                            setEditing(item);
                                                            setEditName(item.name ?? '');
                                                            setEditFile(null);
                                                        }, children: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C" }), _jsx("button", { type: "button", className: "admin-btn admin-btn-danger", disabled: busy, onClick: () => void remove(item), children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })] }) })] }, item.id));
                            }) })] }) }), _jsx(AdminPagination, { page: list.data?.page ?? page, totalPages: list.data?.totalPages ?? 0, onPageChange: setPage }), _jsxs(AdminModal, { open: editing != null, title: `Медиа #${editing?.id ?? ''}`, onClose: () => setEditing(null), footer: _jsxs(_Fragment, { children: [_jsx("button", { type: "button", className: "admin-btn", onClick: () => setEditing(null), children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), _jsx("button", { type: "button", className: "admin-btn admin-btn-primary", disabled: busy, onClick: () => void saveEdit(), children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" })] }), children: [_jsxs("div", { className: "admin-field", children: [_jsx("label", { htmlFor: "media-name", children: "\u0418\u043C\u044F" }), _jsx("input", { id: "media-name", className: "admin-input", value: editName, onChange: (e) => setEditName(e.target.value) })] }), _jsxs("div", { className: "admin-field", children: [_jsx("label", { htmlFor: "media-file", children: "\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u0444\u0430\u0439\u043B" }), _jsx("input", { id: "media-file", type: "file", onChange: (e) => setEditFile(e.target.files?.[0] ?? null) })] })] })] }));
}
